import { SvgIcon, SvgIconProps } from 'ui/icons/SvgIcon';

export const TemplatePreviewCardEmptyState = ({
  height = 128,
  width = 128,
  ...props
}: SvgIconProps) => (
  <SvgIcon height={height} width={width} viewBox="0 0 128 128" {...props}>
    <rect x="33" y="23" width="67" height="82" rx="4" fill="white" />
    <path
      d="M71.5323 87C71.2083 87.0009 70.8873 86.9374 70.5881 86.8132C70.2888 86.689 70.0172 86.5065 69.7891 86.2764L66.5 82.9876L63.2109 86.2764C62.9819 86.5055 62.7099 86.6872 62.4107 86.8111C62.1114 86.9351 61.7906 86.9989 61.4667 86.9989C61.1428 86.9989 60.822 86.9351 60.5227 86.8111C60.2235 86.6872 59.9515 86.5055 59.7225 86.2764C59.4934 86.0474 59.3117 85.7755 59.1878 85.4763C59.0638 85.177 59 84.8563 59 84.5324C59 84.2085 59.0638 83.8877 59.1878 83.5885C59.3117 83.2892 59.4934 83.0173 59.7225 82.7883L63.0116 79.4994L59.7225 76.2106C59.2599 75.748 59 75.1207 59 74.4665C59 73.8123 59.2599 73.185 59.7225 72.7224C60.1851 72.2599 60.8125 72 61.4667 72C62.1209 72 62.7483 72.2599 63.2109 72.7224L66.5 76.0113L69.7891 72.7224C70.2517 72.2599 70.8791 72 71.5333 72C72.1875 72 72.8149 72.2599 73.2775 72.7224C73.7401 73.185 74 73.8123 74 74.4665C74 75.1207 73.7401 75.748 73.2775 76.2106L69.9884 79.4994L73.2775 82.7883C73.622 83.133 73.8566 83.5721 73.9515 84.0502C74.0465 84.5282 73.9976 85.0236 73.811 85.4738C73.6245 85.9241 73.3086 86.3089 72.9034 86.5796C72.4981 86.8504 72.0217 86.9949 71.5343 86.995L71.5323 87Z"
      fill="#EEECED"
    />
    <rect
      x="42.75"
      y="61.75"
      width="47.5"
      height="35.5"
      rx="3.25"
      stroke="#CCC8CA"
      strokeWidth="1.5"
      strokeLinejoin="round"
      strokeDasharray="4 4"
    />
    <line
      x1="41.75"
      y1="48.25"
      x2="67.25"
      y2="48.25"
      stroke="#CCC8CA"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <line
      x1="41.75"
      y1="42.25"
      x2="61.25"
      y2="42.25"
      stroke="#CCC8CA"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <line
      x1="41.75"
      y1="36.25"
      x2="77.25"
      y2="36.25"
      stroke="#CCC8CA"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M34.8298 36.7558C34.9953 36.0433 35.3572 35.3915 35.8743 34.8743C36.3915 34.3572 37.0433 33.9953 37.7558 33.8298L43.6248 32.475C43.7317 32.4494 43.8268 32.3886 43.8949 32.3023C43.963 32.216 44 32.1093 44 31.9994C44 31.8895 43.963 31.7828 43.8949 31.6965C43.8268 31.6102 43.7317 31.5493 43.6248 31.5238L37.7558 30.1702C37.043 30.0055 36.3907 29.6439 35.8734 29.1266C35.3561 28.6093 34.9945 27.957 34.8298 27.2442L33.475 21.3752C33.4494 21.2683 33.3886 21.1731 33.3023 21.1051C33.216 21.037 33.1093 21 32.9994 21C32.8895 21 32.7828 21.037 32.6965 21.1051C32.6102 21.1731 32.5493 21.2683 32.5237 21.3752L31.1702 27.2442C31.0047 27.9567 30.6428 28.6085 30.1257 29.1257C29.6085 29.6428 28.9567 30.0047 28.2442 30.1702L22.3752 31.5238C22.2683 31.5493 22.1731 31.6102 22.1051 31.6965C22.037 31.7828 22 31.8895 22 31.9994C22 32.1093 22.037 32.216 22.1051 32.3023C22.1731 32.3886 22.2683 32.4494 22.3752 32.475L28.2442 33.8298C28.9569 33.9946 29.6089 34.3562 30.126 34.8735C30.6431 35.3909 31.0045 36.043 31.169 36.7558L32.5237 42.6248C32.5493 42.7317 32.6102 42.8269 32.6965 42.8949C32.7828 42.963 32.8895 43 32.9994 43C33.1093 43 33.216 42.963 33.3023 42.8949C33.3886 42.8269 33.4494 42.7317 33.475 42.6248L34.8298 36.7558Z"
      fill="#CC7614"
    />
    <path
      d="M98.4955 60.8895C98.63 60.306 98.9259 59.7721 99.3493 59.3487C99.7727 58.9253 100.307 58.6295 100.89 58.495L105.692 57.3872C105.78 57.3665 105.858 57.3169 105.914 57.2463C105.97 57.1757 106 57.0884 106 56.9984C106 56.9084 105.97 56.8211 105.914 56.7505C105.858 56.68 105.78 56.6303 105.692 56.6096L100.89 55.5018C100.307 55.3676 99.7725 55.0719 99.349 54.6484C98.9255 54.225 98.6297 53.6909 98.4955 53.1073L97.3876 48.312C97.3679 48.2235 97.3187 48.1444 97.248 48.0876C97.1773 48.0309 97.0894 48 96.9987 48C96.9081 48 96.8202 48.0309 96.7495 48.0876C96.6788 48.1444 96.6295 48.2235 96.6099 48.312L95.502 53.1098C95.3676 53.6934 95.0718 54.2274 94.6483 54.6508C94.2249 55.0742 93.6908 55.37 93.1073 55.5044L88.3076 56.6109C88.2201 56.6316 88.142 56.6812 88.0862 56.7518C88.0304 56.8224 88 56.9097 88 56.9997C88 57.0896 88.0304 57.177 88.0862 57.2476C88.142 57.3181 88.2201 57.3678 88.3076 57.3885L93.1073 58.4962C93.6908 58.6308 94.2247 58.9266 94.6482 59.35C95.0716 59.7734 95.3675 60.3073 95.502 60.8908L96.6099 65.6924C96.6306 65.78 96.6803 65.858 96.7508 65.9138C96.8214 65.9696 96.9088 66 96.9987 66C97.0887 66 97.1761 65.9696 97.2466 65.9138C97.3172 65.858 97.3669 65.78 97.3876 65.6924L98.4955 60.8895Z"
      fill="#5156BA"
    />
  </SvgIcon>
);
